import React, { Component } from 'react'
import PropTypes from 'prop-types'
import cn from 'classnames'

export default class extends Component {
  static propTypes = {
    placement: PropTypes.string,
    className: PropTypes.string
  }

  static defaultProps = {
    placement: 'top center'
  }

  state = {
    showing: false
  }

  checkDismissal = (e) => {
    if (this.node !== e.target) return
    this.setState({showing: false})
  }

  componentDidUpdate () {
    const {showing, target} = this.state
    if (!showing || !target) return

    const pos = this.getPosition()
    this.node.style.left = `${pos.left}px`
    this.node.style.top = `${pos.bottom}px`
  }

  getPlacement () {
    let [v, h] = this.props.placement.split(' ')
    const {target} = this.state

    if (target) {
      const bounds = target.getBoundingClientRect()
      if (bounds.top < window.innerHeight * 0.5) {
        v = 'bottom'
      }

      if (bounds.top > window.innerHeight * 0.5) {
        v = 'top'
      }
    }

    return `${v} ${h}`
  }

  getPosition () {
    const {target} = this.state
    if (!target) return

    const {left, bottom, width} = target.getBoundingClientRect()
    const [, h] = this.getPlacement().split(' ')

    if (h === 'center') {
      const w = this.container.offsetWidth
      return {
        left: left - ((w - width) * 0.5),
        bottom
      }
    }

    return {left, bottom}
  }

  render () {
    const {showing} = this.state
    const placement = this.getPlacement()
    const className = cn('popover', placement, this.props.className, {show: showing})

    return <div className={className} onClick={this.checkDismissal} ref={c => (this.node = c)}>
      <div className='popover-container' ref={c => (this.container = c)}>
        <div className='popover-content modal-content'>
          {this.props.children}
        </div>
      </div>
    </div>
  }
}



// WEBPACK FOOTER //
// ./app/components/ui/Popover.js